export const CAPTCHA_SITE_KEY = '6Ld7MnAcAAAAALh0J7zkAOnx8KUHdMMVi0QA7bNj';
